import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { CustomFormControlComponent } from '../../../core/abstractions/custom-form-control.component';
import { RelativeDatePlaceholdersEnum } from '../../../models/enums/relative-date-placeholders.enum';

@Component({
    selector: 'sl-relative-date-input',
    templateUrl: './relative-date-input.component.html',
    styleUrls: ['./relative-date-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: RelativeDateInputComponent
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RelativeDateInputComponent extends CustomFormControlComponent<number> {
    @Input() labelKey: string;
    @Input() class: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    @Input() required: boolean;

    RelativeDatePlaceholders = RelativeDatePlaceholdersEnum;
}
